import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class PaywayDataTask extends AbstractRequestTask {
    constructor(params) {
        super();
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'user-token': params.user_token,
        };
      }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.user_token;
        delete params.api_version;
        return Object.assign({}, params);
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/payway/v1/data`;
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default PaywayDataTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PaywayDataTask.js